<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #deal="{text}">
      <a-button type="link" @click="() => visibleChange(true, text)"
        >编辑</a-button
      >
      <a-popconfirm
        title="是否确定删除该行数据?"
        ok-text="确定"
        cancel-text="取消"
        trigger="click"
        @confirm="() => deleteFun({ ...text })"
        @cancel="cancel"
      >
        <a-button type="link">删除</a-button>
      </a-popconfirm>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      ...toRefs(inject('initState'))
    }
  }
}
</script>
